
<app-titulo [modulo]="titulo" [mostrar]="true"></app-titulo>
<div class="container">
    <div class="d-flex justify-content mt-4">
        <div class="d-flex col-7 mt-2 me-5">
            <label class="col-md-3  col-sm-6 mt-1 me-3">Aplicativo</label>
            <select class="form-select col-md-1 col-sm-8" aria-label="Default select example" [(ngModel)]="idAplicativo"
                (change)="cargarRoles()">
                <option disabled value="0" class="color-gris">Escoja el aplicativo</option>
                <option *ngFor="let item of listaAplicaciones" value="{{ item.idAplicativo }}">{{ item.nombreAplicativo
                    }}
                </option>
            </select>
        </div>
    </div>
    <div class="d-flex justify-content mt-4">
        <div class="d-flex col-7 mt-2 me-5">
            <label class="col-md-3 col-sm-6 mt-1 me-3">Rol</label>
            <select class="form-select col-md-5 col-sm-8" aria-label="Default select example" [(ngModel)]="idRol"
                (change)="cargarUsuarios()">
                <option disabled value="0" class="color-gris">Escoja el rol para el aplicativo</option>
                <option *ngFor="let item of listaRoles" value="{{ item.idRol }}">{{ item.nombreRol}}
                </option>
            </select>
        </div>
    </div>
    <div class="d-flex justify-content mt-4">
        <div class="d-flex col-md-6 mt-1 me-5">
            <label class=" fw-bold col-md-4 align-self-center">Usuarios activos</label>
            <div class="input-group">
                <span class="input-group-text fondo-blanco color-gris radius-2 cursor" (click)="buscar(texto.value)">
                    <i class="fa-solid fa-magnifying-glass"></i>
                </span>
                <input type="text" class="form-control lineas-buscadores" placeholder="Nombre Funcionario" #texto id="caja">
                <span class="input-group-text fondo-blanco color-gris radius-1 cursor" (click)="borrar()" id="cancel">
                    <i class="fa-solid fa-circle-xmark"></i>
                </span>
            </div>
        </div>
        <div class="d-flex col-md-5 mt-1 ms-5">
        </div>
    </div>
    <div class="d-flex justify-content-center mt-4">
        <div class="col-lg-12 mt-4">
            <table class="table mt-2"  aria-describedby="mydesc">
                <thead class="fondo-gris">
                    <tr>
                        <th scope="col"><input type="checkbox" class="me-3" id="all" value="0"
                                (change)="todos($event)">Selección</th>
                        <th scope="col" class="text-center">Nombre funcionario</th>
                        <th scope="col" class="text-center">Nombre usuario</th>

                        <th scope="col" class="text-center">Cargo</th>
                        <th scope="col" class="text-center">Área</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let usuario of usuarios | paginate: { itemsPerPage: 10, currentPage: pagina }">
                        <td><input type="checkbox" [checked]="usuario.inicio" (change)="agregarUsuario($event)"
                                value="{{ usuario.idUsuario }}"></td>
                        <td class="text-center">{{ usuario.nombreUsuario }}</td>
                        <td class="text-center">{{ usuario.email }}</td>
                        <td class="text-center">{{ usuario.perfil }}</td>
                        <td class="text-center">{{ usuario.area }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="d-flex justify-content-end mt-2">
                <pagination-controls class="clase-paginador" (pageChange)="pagina = $event" previousLabel="Anterior"
                    nextLabel="Siguiente"></pagination-controls>
            </div>
        </div>
    </div>
    <div class="d-flex justify-content mt-4">
        <div class="d-flex col-md-6 mt-2 me-5">
            <button class="btn btn-primary" (click)="quitar()">Retirar del rol a los usuarios seleccionados</button>
        </div>
    </div>
</div>
